<script lang="ts">import { cfgEventThemeCdnPath, cfgToThemeCdnPath, isEventAssetEnabled } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
import { stateFormMode } from "../state";
import { FormMode } from "../types";
$: useEventLogo = isEventAssetEnabled("customLogo");
$: logoPath = useEventLogo ? cfgEventThemeCdnPath("customlogo.png") : cfgToThemeCdnPath("/misc/logo.svg");
$: isLogin = $stateFormMode === FormMode.Login;
$: eyebrowKey = isLogin ? Verbiage.auth_hero_login_eyebrow : Verbiage.auth_hero_register_eyebrow;
$: titleKey = isLogin ? Verbiage.auth_hero_login_title : Verbiage.auth_hero_register_title;
$: descriptionKey = isLogin ? Verbiage.auth_hero_login_description : Verbiage.auth_hero_register_description;
</script>

<div class="auth-hero-banner">
	<img class="auth-hero-logo" src={logoPath} alt={$t(Verbiage.site_logo_alt, 'alts')} />

	<InfoCard
		width="100%"
		borderRadius="16px"
		customStyles="min-height: 112px;"
		customStylesCard="border-radius: 16px;"
		customStylesCardContent="padding: 16px 18px;"
	>
		{#key $stateFormMode}
			<div class="auth-hero-text">
				<Text
					type="body"
					bodySize="xsmall"
					bodyWeight="extrabold"
					textColor="primary"
					customStyle="text-transform: uppercase; letter-spacing: 0.06em;"
				>
					{$t(eyebrowKey)}
				</Text>
				<Text type="title" titleSize="h5" titleWeight="extrabold">
					{$t(titleKey)}
				</Text>
				<Text type="body" bodySize="small" textColor="gray">
					{$t(descriptionKey)}
				</Text>
			</div>
		{/key}
	</InfoCard>
</div>

<style>
	.auth-hero-banner {

    display: flex;

    width: 100%;

    flex-direction: column;

    align-items: flex-start;

    gap: 0.75rem
}

	.auth-hero-logo {

    height: 2rem;

    width: auto;

    max-width: 140px;

    -o-object-fit: contain;

       object-fit: contain
}

	.auth-hero-text {

    display: flex;

    flex-direction: column;

    align-items: flex-start;

    gap: 5px;

    text-align: start
}
</style>
